import { css } from "@emotion/react";
import { Grid, IconButton } from "@mui/material";
import { convertToWebP } from "@unit/utility";
import localforage from "localforage";
import React from "react";
import { MdClose } from "react-icons/md";

import { useGlobalDialog } from "@/custom-hooks/jotai/use-global-dialog";
import { useSpotlightState } from "@/custom-hooks/jotai/use-spotlight-state";
import { useTicketListDisplay } from "@/custom-hooks/jotai/use-ticket-list-display";
import { noImageUrl3x4 } from "@/global-state/influencer-app-path";

const SpotlightPopupPane: React.FC = () => {
  const { closeDialog } = useGlobalDialog();
  const { editingDisplay, setTicketFilter } = useTicketListDisplay();
  const { ticketFilter } = editingDisplay;
  const { popupSpotlight } = useSpotlightState();

  const handleClick = async () => {
    await handleClose();
    await setTicketFilter({ ...ticketFilter, spotlights: popupSpotlight ? [popupSpotlight] : [] }, true);
  };
  const handleClose = async () => {
    closeDialog();
    if (popupSpotlight?.id) {
      await localforage.setItem("popupSpotlightId", popupSpotlight.id);
    }
  };

  return (
    <Grid css={style.modal}>
      <img
        alt={"ticket-Image"}
        src={popupSpotlight?.popupImageUrl || noImageUrl3x4}
        srcSet={popupSpotlight?.popupImageUrl || noImageUrl3x4}
        loading="lazy"
        onClick={handleClick}
      />
      <Grid pt={2} css={style.closeButton}>
        <IconButton size="large" onClick={handleClose}>
          <MdClose size={30} color={"#000"} />
        </IconButton>
      </Grid>
    </Grid>
  );
};
export default React.memo(SpotlightPopupPane);

const style = {
  modal: css`
    background-color: transparent;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 16px;
    }
  `,
  closeButton: css`
    text-align: center;
    button {
      height: 64px;
      width: 64px;
      background-color: white;
      font-weight: bold;
      &:hover {
        background-color: white;
        font-weight: bold;
      }
    }
  `,
};
